export default "__VITE_ASSET__CzkDxbKa__"